import React from 'react';
import { GoalSettingsPage } from '@front-activerse/modules';
import { useAllSettings } from '../context/AllSettingsContext';
import goalDescendantRoutes from '../../GoalSettings/descendantRoutes';

const GoalSettingsWrapper: React.FC = () => {
  const { setCurrentModule } = useAllSettings();

  // Set current module when this component mounts
  React.useEffect(() => {
    setCurrentModule('goal-settings');
  }, [setCurrentModule]);

  return <GoalSettingsPage descendantRoutes={goalDescendantRoutes} />;
};

export default GoalSettingsWrapper;
